import {combineReducers} from 'redux';

import {reduce as settings} from './settings.view/settings.redux';

export default combineReducers({
  settings,
});
